import { Badge, NumberFormatter, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./ConfidenceBadge.module.css";

export default function ConfidenceIcon({ confidence }) {
  const { t } = useTranslation("pim");
  if (!confidence) return null;
  let color = "green";
  if (confidence < 0.8) color = "yellow";
  if (confidence < 0.6) color = "red";
  return (
    <Tooltip label={t("legacyProducts.confidenceTooltip")}>
      <Badge
        color={color}
        variant="dot"
        classNames={{ label: classes.badgeLabel }}
      >
        <NumberFormatter
          value={confidence * 100}
          suffix=" %"
          decimalScale={2}
        />
      </Badge>
    </Tooltip>
  );
}
